import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
const COGNITO_URL = "https://airbus-dev-10874-2j17.auth.eu-west-1.amazoncognito.com/"
const COGNITO_CLIENT_ID = "79usid8ol9vhce32j360f3ug81";
const OAUTH_REDIRECT_URI = "https://skywise.api.dev.2j17.aws.airbus-v.cloud/client_login/";
const CognitoLogin = (props) => {
    const navigate = useNavigate();
    const isAuthenticate = useSelector((state)=> state.auth.isAuthenticate);
    const isCognitoAuthenticated = useSelector((state)=> state.auth.isCognitoAuthenticated);
    useEffect(() => {
        if (!isAuthenticate && !isCognitoAuthenticated) {
            window.location = `${COGNITO_URL}/login?client_id=${COGNITO_CLIENT_ID}&response_type=code&scope=email+openid+phone+profile&redirect_uri=${OAUTH_REDIRECT_URI}`
        } else if(isCognitoAuthenticated && !isAuthenticate) {
            return navigate("/login");
        } else{
            return navigate("/home");
        }
      }, []);
    return;  
}
export default CognitoLogin;